var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuPostNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.88,0H24a1.26,1.26,0,0,0-.9.37l-9.94,10a1.26,1.26,0,0,0-.37.9V30.73A1.27,1.27,0,0,0,14.1,32H39.88a1.27,1.27,0,0,0,1.27-1.27V1.27A1.27,1.27,0,0,0,39.88,0ZM23.68,3.43v7.42H16.29ZM38.6,8.2V29.46H15.37V13.39H25a1.27,1.27,0,0,0,1.27-1.27V2.54H38.6V8.2Z",
    transform: "translate(-12.83)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPostNew);
export default __webpack_public_path__ + "static/media/menu-post-new.44a872ec.svg";
export { ForwardRef as ReactComponent };